import React from 'react';

import Grid from '~/components/core/Atomic/Grid/Grid';
import SimpleSearchField from '~/components/core/SimpleSearchField';
import { LobMultiSelect } from '~/components/TPA/LOB/LobMultiselect';
import SubOrganizationMultiSelect from '~/components/TPA/SubOrganizations/SubOrganizationMultiSelect';

interface Organization {
  id: number;
  sub_organizations_enabled: boolean;
  sub_organizations?: { id: number; name: string }[];
  [key: string]: unknown;
}

interface FilteredParams {
  subOrgIds: number[];
  lobs: string[];
  searchTerm: string;
}

interface WorkflowRulesFiltersProps {
  organization: Organization;
  filteredParams: FilteredParams;
  onSubOrgChanged: (subOrgIds: number[]) => void;
  onLobsChanged: (lobs: string[]) => void;
  onSearchTermChanged: (searchTerm: string) => void;
}

export const WorkflowRulesFilters: React.FC<WorkflowRulesFiltersProps> = ({
  organization,
  filteredParams,
  onSubOrgChanged,
  onLobsChanged,
  onSearchTermChanged,
}) => {
  return (
    <Grid container spacing={2} className="inline-flex items-baseline pb-40">
      <Grid item xs={4} className="inline-flex">
        <SimpleSearchField label="Search Rule" placeholder="Search" onChange={onSearchTermChanged} />
      </Grid>
      {organization.sub_organizations_enabled && (
        <Grid item xs={4} className="inline-flex">
          <SubOrganizationMultiSelect onChange={onSubOrgChanged} />
        </Grid>
      )}
      <Grid item xs={4} className="inline-flex">
        <LobMultiSelect subOrganizationIds={filteredParams.subOrgIds as never[]} onChange={onLobsChanged} />
      </Grid>
    </Grid>
  );
};
